import { render, staticRenderFns } from "./HomePopup.vue?vue&type=template&id=1c033863&scoped=true&"
import script from "./HomePopup.vue?vue&type=script&lang=js&"
export * from "./HomePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c033863",
  null
  
)

export default component.exports